import config from '../../config';
import AnimatedParticle from './AnimatedParticle';

let dataManager;
let soundManager;

// HIGH LEVEL TILE MATCH LOGIC
function TileMatch (tileA, tileB) {
  let g = this.g;

  if (!dataManager) {
    dataManager = g.sys.game.dataManager;
    soundManager = g.scene.get('SoundManager');
  }

  tileA.bracket.play('bracket-match');
  tileB.bracket.play('bracket-match');
  this.removeListeners();
  g.time.delayedCall(100, () => {
    tileA.bracket.play('bracket-hidden');
    tileB.bracket.play('bracket-hidden');
    if (tileA.tween) {
      tileA.tween.stop();
    }
    if (tileB.tween) {
      tileB.tween.stop();
    }
    tileA.sprite.setAlpha(0);
    tileA.bracket.play('bracket-hidden');
    tileA.isActive = false;
    tileB.sprite.setAlpha(0);
    tileB.bracket.play('bracket-hidden');
    tileB.isActive = false;
    tileA.isHint = false;
    tileB.isHint = false;
    this.selectedTile = null;

    // THE TILE CONTAINS A BEAR OR ITEM
    if (tileA.bearType || tileB.bearType) {
      // THE TILE CONTAINS A BEAR
      let bearType = tileA.bearType || tileB.bearType;
      // this.bearsFound++;
      this.bearsFound.push(bearType);
      BearFound.call(this, tileA, tileB, bearType);
      // TODO: CHECK IF TILE CONTAINS AN ITEM
    } else if (tileA.collectableType || tileB.collectableType) {
      this.collectableFound++;
      let collectableType = tileA.collectableType || tileB.collectableType;
      CollectableFound.call(this, tileA, tileB, collectableType);
    } else {
      // TILE DOES NOT CONTAIN AN ITEM, STANDARD MATCH
      this.checkBoard();
      StandardMatch.call(this, [tileA, tileB]);
    }
  });
}

function StandardMatch (tiles) {
  let g = this.g;
  soundManager.playSound('box-open');
  dataManager.addPoints(config.POINTS.MATCH * 2);
  dataManager.addCoins(config.COINS_PER_BOX * 2);
  // console.log('standard match points x2');
  let particle = g.add.particles('packing');
  let emitter = particle.createEmitter({
    x: config.CENTER_X,
    y: config.CENTER_Y,
    speed: { min: 50, max: 400 },
    accelerationX: { min: -50, max: 50 },
    accelerationY: { min: -50, max: 50 },
    angle: { min: 0, max: 360 },
    // scale: { start: 0, end: 0.5 },
    scale: 0.2,
    lifespan: 750,
    particleClass: AnimatedParticle,
    on: false
  });
  let tempTiles = [];
  _.each(tiles, (tile) => {
    let temp = g.add.sprite(tile.x, tile.y, 'tiles-open');
    temp.setFrame(tile.sprite.frame.name);
    tempTiles.push(temp);
    emitter.explode(50, temp.x, temp.y);
  });
  g.tweens.add({
    targets: tempTiles,
    alpha: 0,
    duration: 250,
    onComplete: () => {
      tempTiles[0].destroy();
      tempTiles[1].destroy();
    }
  });
  g.time.delayedCall(1250, () => {
    particle.destroy();
  });
}

// ITEM REAVEAL SEQUENCE
function CollectableFound (tileA, tileB, collectableType) {
  let g = this.g;

  console.log('Collectable Found', collectableType);
  // session collectable count, used for increasing the score for each one found throughout a play session
  let sessionCollectableCount = dataManager.getSessionItem('collectableCount');
  // increase the collectable count if it is less than the total number of collectables available
  sessionCollectableCount = sessionCollectableCount < config.COLLECTABLE_TOTAL ? sessionCollectableCount + 1 : config.COLLECTABLE_TOTAL;
  // save the session count
  dataManager.setSessionItem('collectableCount', sessionCollectableCount);
  // inital length check to see if we've already found all items
  let collectableState = dataManager.getItem('collectables');
  // inital length check to see if we've already found all items
  if (collectableState.length < config.COLLECTABLE_TOTAL) {
    // if so, check if the item already exists in the collectableState array
    if (collectableState.indexOf(collectableType) === -1) {
      console.log('TileMatch.js New Collectable Found', collectableType);
      collectableState.push(collectableType);
      dataManager.setItem('collectables', collectableState);
      console.log('TileMatch.js collectables state saved', collectableState);
    } else {
      console.log('TileMatch.js Already collected', collectableState);
    }
  } else {
    console.log('TileMatch.js All collectables already found');
  }

  soundManager.playSound('found-object');

  g.disablePowerUpButtons();

  let collectablePointValue = config.POINTS.COLLECTABLE * sessionCollectableCount;
  console.log('collectablePointValue', collectablePointValue);
  dataManager.addPoints(collectablePointValue + config.POINTS.MATCH * 2);
  dataManager.addCoins(config.COINS_PER_BOX * 2);
  // console.log('Collectable points + 2x standard match', collectablePointValue);

  if (tileB.sprite.x < tileA.sprite.x) {
    let a = tileA;
    let b = tileB;
    tileA = b;
    tileB = a;
  }

  let spriteA = g.add.sprite(tileA.x, tileA.y, 'tiles-closed');
  spriteA.setFrame(tileA.sprite.frame.name);
  let spriteB = g.add.sprite(tileB.x, tileB.y, 'tiles-closed');
  spriteB.setFrame(tileB.sprite.frame.name);
  g.children.bringToTop(spriteA);

  tileA.timeline = g.tweens.createTimeline();
  tileA.timeline.add({
    targets: spriteA,
    x: config.CENTER_X - 100,
    y: config.CENTER_Y,
    duration: 250
  });
  tileA.timeline.add({
    targets: spriteA,
    x: config.CENTER_X - 35,
    y: config.CENTER_Y,
    duration: 250
  });
  tileA.timeline.add({
    targets: spriteA,
    x: config.CENTER_X - 50,
    y: config.CENTER_Y,
    duration: 250
  });
  tileA.timeline.add({
    targets: spriteA,
    x: config.CENTER_X,
    y: config.CENTER_Y,
    duration: 250
  });
  tileB.timeline = g.tweens.createTimeline();
  tileB.timeline.add({
    targets: spriteB,
    x: config.CENTER_X + 100,
    y: config.CENTER_Y,
    duration: 250
  });
  tileB.timeline.add({
    targets: spriteB,
    x: config.CENTER_X + 35,
    y: config.CENTER_Y,
    duration: 250
  });
  tileB.timeline.add({
    targets: spriteB,
    x: config.CENTER_X + 50,
    y: config.CENTER_Y,
    duration: 250
  });
  tileB.timeline.add({
    targets: spriteB,
    x: config.CENTER_X,
    y: config.CENTER_Y,
    duration: 250,
    onComplete: () => {
      let boxOpen = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'tiles-open');
      boxOpen.setFrame(spriteA.frame.name);

      spriteA.destroy();
      spriteB.destroy();

      let collectable = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'collectables');
      collectable.setFrame(collectableType);
      collectable.setScale(0.125);

      let bonusStr = g.sys.game.localisationManager.GetString("collectable_bonus");
      bonusStr = bonusStr.replace("<!VALUE>", (collectablePointValue + config.POINTS.MATCH * 2));
      let bonusText = g.showScoreBonus(bonusStr);
      g.children.bringToTop(collectable);

      soundManager.playSound('vo-found-object');
      soundManager.playSound('box-open');

      let collectableTimeline = g.tweens.createTimeline();
      collectableTimeline.add({
        targets: collectable,
        scaleX: 1,
        scaleY: 1,
        ease: 'Back.easeOut',
        duration: 750,
        delay: 100,
        onComplete: () => {
          boxOpen.destroy();
        }
      });
      collectableTimeline.add({
        targets: collectable,
        scaleX: 1.25,
        scaleY: 1.25,
        alpha: 0,
        // ease: 'Back.easeOut',
        delay: 500,
        duration: 250,
        onComplete: () => {
          this.checkBoard();
          g.enablePowerUpButtons();
        }
      });
      let particle = g.add.particles('packing');
      let emitter = particle.createEmitter({
        x: config.CENTER_X,
        y: config.CENTER_Y,
        speed: { min: 200, max: 700 },
        accelerationX: { min: -50, max: 50 },
        accelerationY: { min: -50, max: 50 },
        angle: { min: 0, max: 360 },
        scale: { start: 0.2, end: 1.2 },
        lifespan: 1250,
        particleClass: AnimatedParticle,
        on: false
      });
      emitter.explode(200);
      collectableTimeline.play();
      // g.children.bringToTop(bonusText[0]);
      // g.children.bringToTop(bonusText[1]);
    }
  });

  tileA.timeline.play();
  tileB.timeline.play();
}

// BEAR REVEAL SEQUENCE
function BearFound (tileA, tileB, bearType) {
  let g = this.g;

  soundManager.playSound('found-bear');

  tileA.bearType = null;
  tileB.bearType = null;

  g.disablePowerUpButtons();

  dataManager.addPoints(config.POINTS.BEAR + config.POINTS.MATCH * 2);
  dataManager.addCoins(config.COINS_PER_BOX * 2);
  // console.log('bear points + 2x standard match');

  if (tileB.sprite.x < tileA.sprite.x) {
    let a = tileA;
    let b = tileB;
    tileA = b;
    tileB = a;
  }

  let spriteA = g.add.sprite(tileA.x, tileA.y, 'tiles-closed');
  spriteA.setFrame(tileA.sprite.frame.name);
  let spriteB = g.add.sprite(tileB.x, tileB.y, 'tiles-closed');
  spriteB.setFrame(tileB.sprite.frame.name);
  g.children.bringToTop(spriteA);

  tileA.timeline = g.tweens.createTimeline();
  tileA.timeline.add({
    targets: spriteA,
    x: config.CENTER_X - 100,
    y: config.CENTER_Y,
    duration: 250
  });
  tileA.timeline.add({
    targets: spriteA,
    x: config.CENTER_X - 35,
    y: config.CENTER_Y,
    duration: 250
  });
  tileA.timeline.add({
    targets: spriteA,
    x: config.CENTER_X - 50,
    y: config.CENTER_Y,
    duration: 250
  });
  tileA.timeline.add({
    targets: spriteA,
    x: config.CENTER_X,
    y: config.CENTER_Y,
    duration: 250
  });
  tileB.timeline = g.tweens.createTimeline();
  tileB.timeline.add({
    targets: spriteB,
    x: config.CENTER_X + 100,
    y: config.CENTER_Y,
    duration: 250
  });
  tileB.timeline.add({
    targets: spriteB,
    x: config.CENTER_X + 35,
    y: config.CENTER_Y,
    duration: 250
  });
  tileB.timeline.add({
    targets: spriteB,
    x: config.CENTER_X + 50,
    y: config.CENTER_Y,
    duration: 250
  });
  tileB.timeline.add({
    targets: spriteB,
    x: config.CENTER_X,
    y: config.CENTER_Y,
    duration: 250,
    onComplete: () => {
      let boxOpen = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'tiles-open');
      boxOpen.setFrame(spriteA.frame.name);

      spriteA.destroy();
      spriteB.destroy();

      let bear = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'play-bears');
      bear.setFrame(bearType + _.random(1, 3) + '.png');
      bear.setScale(0.125);
      soundManager.playSound('box-open');
      switch (bearType) {
        case 'grizz':
          soundManager.playSound('vo-found-grizz');
          break;
      }

      let bonusStr = g.sys.game.localisationManager.GetString("bear_bonus");
      bonusStr = bonusStr.replace("<!VALUE>", (config.POINTS.BEAR + config.POINTS.MATCH * 2));
      let bonusText = g.showScoreBonus(bonusStr);
      g.children.bringToTop(bear);

      let bearTimeline = g.tweens.createTimeline();
      bearTimeline.add({
        targets: bear,
        scaleX: 1,
        scaleY: 1,
        ease: 'Back.easeOut',
        duration: 750,
        delay: 100,
        onComplete: () => {
          boxOpen.destroy();
        }
      });
      bearTimeline.add({
        targets: bear,
        scaleX: 1.25,
        scaleY: 1.25,
        alpha: 0,
        // ease: 'Back.easeOut',
        delay: 500,
        duration: 250,
        onComplete: () => {
          this.checkBoard();
          g.enablePowerUpButtons();
        }
      });
      let particle = g.add.particles('packing');
      let emitter = particle.createEmitter({
        x: config.CENTER_X,
        y: config.CENTER_Y,
        speed: { min: 200, max: 700 },
        accelerationX: { min: -50, max: 50 },
        accelerationY: { min: -50, max: 50 },
        angle: { min: 0, max: 360 },
        scale: { start: 0.2, end: 1.2 },
        lifespan: 1250,
        particleClass: AnimatedParticle,
        on: false
      });
      emitter.explode(200);
      bearTimeline.play();
      // g.children.bringToTop(bonusText[0]);
      // g.children.bringToTop(bonusText[1]);
    }
  });

  tileA.timeline.play();
  tileB.timeline.play();
}

export default TileMatch;
